// extracted by mini-css-extract-plugin
module.exports = {"alertTriangle":"styles-module--alertTriangle--1NdNw","feedbackText":"styles-module--feedbackText--1b2RX"};